import React, { Suspense, lazy } from 'react';

import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';

const PortfolioInvestAssetList = lazy(
  () => import('@components/Group/Portfolio/PortfolioInvestAssetList')
);

const InvestAsset = () => {
  return (
    <>
      <ApiErrorBoundary>
        <Suspense fallback={<div>불러오는중 입니다....</div>}>
          <PortfolioInvestAssetList />
        </Suspense>
      </ApiErrorBoundary>
    </>
  );
};

export default InvestAsset;
